var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Müşteri Geçmişi"}},[_c('statistic'),_c('tab-details')],1)}
var staticRenderFns = []

export { render, staticRenderFns }